/**
 * The one place message body typography is defined. The composer, the macro
 * editor, the sent message in the timeline and the mail that leaves for the
 * recipient all read from these numbers, so a reply looks the same while it is
 * drafted and after it is sent.
 *
 * Inside the app the numbers ship as Tailwind classes
 * (`typographyVariants({ variant: "message" })`) and as the plain CSS in
 * `MESSAGE_BODY_CSS` for the shadow DOM a sent message renders into. On the wire
 * they ship as inline styles, since a mail client has neither.
 * `packages/ui/src/components/message-typography.test.ts` fails when the sides
 * drift apart.
 */
export const MESSAGE_TYPOGRAPHY = {
	fontSize: "0.875rem",
	lineHeight: "1.45",
	/** Blank lines come from empty paragraphs, never from paragraph margins. */
	paragraphMargin: "0",
	headingSize: {
		h1: "1.5rem",
		h2: "1.25rem",
		h3: "1.125rem",
		h4: "1rem",
	},
	headingWeight: "600",
	headingLineHeight: "1.3",
	headingMargin: "0.75em 0 0.35em",
	listMargin: "0.5em 0",
	listIndent: "1.5em",
	listItemMargin: "0.25em 0",
	blockquoteMargin: "0.5em 0",
	blockquotePadding: "0.75em",
	ruleMargin: "0.75em 0",
	codeFontSize: "0.8125rem",
} as const
